import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

export const getMinFuel = createAsyncThunk(
    "fuel/getMin",
    async ({search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"Master/Fuel/getAll",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                let newObj = [];
                response.data.data.map((item) =>
                    newObj.push({
                        value: item.FuelID,
                        label: item.FuelName,
                    })
                );
                return {data: newObj};
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const getFuel = createAsyncThunk(
    "fuel/get",
    async ({start, count, search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("start", start);
        formData.append("count", count);
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"Master/Fuel/getAll",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const insertFuel = createAsyncThunk(
    "fuel/insert",
    async ({FuelName}, thunkAPI) => {
        let formData = new FormData();
        formData.append("FuelName", FuelName);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"Master/Fuel/insert",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const updateFuel = createAsyncThunk(
    "fuel/update",
    async ({FuelName, FuelID, status}, thunkAPI) => {
        let formData = new FormData();
        formData.append("FuelName", FuelName);
        formData.append("FuelID", FuelID);
        formData.append("Status", status);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"Master/Fuel/update",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

const initialState = {
    message: "",
    minData: [],
    isMinFetching: false,
    isMinSuccess: false,
    isMinError: false,
    isGetFetching: false,
    isGetSuccess: false,
    isGetError: false,
    isInsertFetching: false,
    isInsertSuccess: false,
    isInsertError: false,
    isUpdateFetching: false,
    isUpdateSuccess: false,
    isUpdateError: false,
    errorMessage: "",
};

export const fuelSlice = createSlice({
    name: "fuel",
    initialState,
    reducers: {},
    extraReducers: {
        [getMinFuel.fulfilled]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinSuccess = true;
            state.minData = payload.data;
            return state;
        },
        [getMinFuel.rejected]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinError = true;
            state.errorMessage = payload.message;
        },
        [getMinFuel.pending]: (state) => {
            state.isMinFetching = true;
        },

        [getFuel.fulfilled]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.data = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [getFuel.rejected]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetError = true;
            state.errorMessage = payload.message;
        },
        [getFuel.pending]: (state) => {
            state.isGetFetching = true;
        },

        // INSERT
        [insertFuel.fulfilled]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [insertFuel.rejected]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertError = true;
            state.errorMessage = payload.message;
        },
        [insertFuel.pending]: (state) => {
            state.isInsertFetching = true;
        },

        // UPDATE
        [updateFuel.fulfilled]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [updateFuel.rejected]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;
            state.errorMessage = payload.message;
        },
        [updateFuel.pending]: (state) => {
            state.isUpdateFetching = true;
        },
    },
});

export const fuelSelector = (state) => state.fuel;
